export const DATE_LABEL = 'Date:';
export const SLOT_LABEL = 'Time:';
export const NAME_LABEL = 'Name:';
export const PHONE_LABEL = 'Phone number:';
export const EMAIL_LABEL = 'Email:';
export const EDIT_DETAILS_LABEL = 'Edit these details';
export const CONFIRM_LABEL = 'Confirm';
export const CANCEL_LABEL = 'Cancel';

export const ANALYTICS_APPT_MODAL = 'amend appt confirmation model';
export const ANALYTICS_APPT_MODAL_EDIT = 'amend appt confirmation:Edit these details';
export const ANALYTICS_APPT_MODAL_CONFIRM = 'amend appt confirmation:Confirm';
export const ANALYTICS_APPT_MODAL_CANCEL = 'amend appt confirmation:Cancel';
export const MEDALLIA_AMMEND_FORM_ID = '5841';
